import { ERROR_SCREEN_TYPES, ERROR_VIEW } from 'config/config';
import withContext from 'hoc/withContext';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import withTextContext from '../../../hoc/withTextContext';

import {
  ErrorViewContainer,
  ErrorViewIcon,
  ErrorViewMessage,
  ErrorViewStatus,
  ErrorViewStatusText,
  ErrorViewWrapper,
} from './ErrorView.styles';

interface IProps extends Partial<IContext>, Partial<ITextContext> {
  screenType?: string;
}

class ErrorView extends PureComponent<IProps> {
  componentDidMount() {
    const { setPaymentStatusText } = this.props;
    if (setPaymentStatusText) {
      setPaymentStatusText();
    }
  }

  render() {
    const { screenType = ERROR_SCREEN_TYPES.DEFAULT } = this.props;
    const { ICON } = ERROR_VIEW;
    const { status, statusText, description } = ERROR_VIEW[screenType];
    return (
      <ErrorViewContainer className="error-view__container">
        <ErrorViewWrapper>
          <ErrorViewStatus className="error-view__status">
            <p>
              <FormattedMessage id={status} />
            </p>
          </ErrorViewStatus>
          <ErrorViewStatusText className="error-view__statusText">
            <p>
              <FormattedMessage id={statusText} />
            </p>
          </ErrorViewStatusText>
          <ErrorViewIcon className="error-view__icon">
            <img src={ICON} alt="icon" />
          </ErrorViewIcon>
          <ErrorViewMessage className="error-view__message">
            <FormattedMessage id={description} />
          </ErrorViewMessage>
        </ErrorViewWrapper>
      </ErrorViewContainer>
    );
  }
}

export default withContext(withTextContext(ErrorView));
